import apiClient from "../../../api/apiClient";
import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import { WithdrawalRevertRequest } from "../../withdraw/models";
import { WalletHistoryRequest } from "../models/request/walletHistoryRequest";
import { LastWithdrawalResponse } from "../models/response/lastWithdrawalResponse";
import { WalletHistoryResponse } from "../models/response/walletHistoryResponse";

export const walletHistoryAPI = {
  getWalletHistoryApi: async (request: WalletHistoryRequest): Promise<UnifiedResponse<WalletHistoryResponse>> => {
    const response = await apiClient.post<UnifiedResponse<WalletHistoryResponse>>("/users/wallet/retrieve/details", request);
    return response.data;
  },

  withdrawalLastRequestApi: async (): Promise<UnifiedResponse<LastWithdrawalResponse>> => {
    const response = await apiClient.post<UnifiedResponse<LastWithdrawalResponse>>("/payment/withdraw/retrieve_last_request");
    return response.data;
  },

  userWithdrawRevertApi: async (request: WithdrawalRevertRequest): Promise<UnifiedResponse<any | null>> => {
    const response = await apiClient.post<UnifiedResponse<any | null>>("payment/withdraw/cancel", request);
    return response.data;
  },
}